import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import {
    IngameAnimationService,
    IngameAnimationSettings,
} from 'src/app/core/ingame-animation/services/ingame-animation.service';

@Component({
    selector: 'app-ingame-animation',
    templateUrl: './ingame-animation.component.html',
    styleUrls: ['./ingame-animation.component.css'],
    standalone: true,
    imports: [CommonModule],
})
export class IngameAnimationComponent implements OnInit {
    protected ingameAnimationService: IngameAnimationService = inject(IngameAnimationService);

    public isVisible: WritableSignal<boolean> = signal(false);
    public isHiding: WritableSignal<boolean> = signal(false);
    public animationSettings: WritableSignal<IngameAnimationSettings | null> = signal(null);

    private overlayTimeout: ReturnType<typeof setTimeout>;

    public ngOnInit(): void {
        this.ingameAnimationService.animationStatus.subscribe(({ isVisible, animationSettings, duration }) => {
            this.animationSettings.set(animationSettings);
            this.isVisible.set(isVisible);

            if (isVisible && duration > 0) {
                // Ensure overlay stays visible until the last animation is done
                this.clearTimeout();
                this.overlayTimeout = setTimeout(
                    () => {
                        this.startHiding();
                    },
                    duration || this.animationSettings().delay + this.animationSettings().duration
                );
            }
        });

        this.ingameAnimationService.hideAnimationsManually.subscribe(() => {
            this.clearTimeout();
            this.startHiding();
        });
    }

    private startHiding(): void {
        this.isHiding.set(true);
        setTimeout(() => {
            this.isVisible.set(false);
            this.isHiding.set(false);
        }, this.animationSettings().hideDuration || 0);
    }

    private clearTimeout(): void {
        if (this.overlayTimeout) {
            clearTimeout(this.overlayTimeout);
            this.overlayTimeout = null;
        }
    }
}
